import moment from 'moment'

export default function (eventSeasonSettings, startdate) {		   
	if(eventSeasonSettings) {
		const { templateReleaseDays } = eventSeasonSettings
		const today = moment()
		const eventdate = moment(startdate)
		const tillEvent = moment.duration(moment(eventdate).diff(today)).asDays()

		if(tillEvent > templateReleaseDays ) {
				return false
		}
		return true
	}
	return false
}


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/EventTemplate/Logic/allowTemplateDownload.js